// extracted by mini-css-extract-plugin
module.exports = {"categories":"n_8","categoriesHeadline":"n_9 d_p","category":"n_bb"};